import type { LocalizedString } from "@repo/shared/types";
import { useOutletContext } from "react-router";

export type ProductsTabDeleteTarget = {
  id: string;
  nameI18n: LocalizedString;
};

export type ProductsTabContext = {
  collectionId: string;
  debouncedSearch: string;
  openEdit: (productId: string) => void;
  openDelete: (product: ProductsTabDeleteTarget) => void;
  loadingProductId: string | null;
  /** QL-168 — the product whose delete check is in flight, for a `loading` Delete button. */
  checkingDeleteId: string | null;
};

export const useProductsTabContext = () => useOutletContext<ProductsTabContext>();
